import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileGradeSystemSectionTranslation = SectionTranslationModel<{
  finalGrade: string;
  potentialGrade: string;
  qualitativeGrade: string;
  quantitativeGrade: string;
  sectionTitle: string;
}>;

export const employeeProfileGradeSystemSectionTranslation: EmployeeProfileGradeSystemSectionTranslation =
  {
    content: {
      finalGrade: 'Ocena końcowa',
      potentialGrade: 'Potencjał',
      qualitativeGrade: 'Ocena jakościowa',
      quantitativeGrade: 'Ocena ilościowa',
      sectionTitle: 'Wynik Oceny Rocznej',
    },
    headerTitle: 'System oceny',
    headerTitleShorter: 'System oceny',
  };
